import "./Profileview.css";
import userAvatar from "../img/user-avatar.png";
import profilelocation from "../icons/profile-view-location.png";
import heartIcon from "../icons/white-heart.png";
import messageIcon from "../icons/message.png";
import whiteStarIcon from "../icons/white-star.png";
import readMoreIcon from "../icons/down-arrow.png";
import { use, useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import { fetchProfile } from "../redux/profileFilterSlice";
import { useDispatch, useSelector } from "react-redux";
import { sendInterestToProfile, userAddShortlistProfile } from "../redux/matchFilterSlice";
import addfavStarIcon from "../icons/add-short.png";
import removefavStarIcon from "../icons/fav-star.png";
import { io } from "socket.io-client";
import { createConversation, sendChatMessage, getMessages } from "../services/chatService";
import IMG11 from "../img/SSimg1.png";
import {useTranslation} from "react-i18next";
import Loader from "./Loader";


export default function Profileview() {
  const { t } = useTranslation();
  const [interested, setInterested] = useState(false);
  const [saved, setSaved] = useState(false);
  const [expanded, setExpanded] = useState(false);
  const [toast, setToast] = useState(null);
  const [selectedUser, setSelectedUser] = useState(null);
  const [profileImageName, setProfileName] = useState("");
  const [loading, setLoading] = useState(false);
  const { id } = useParams(); // 👈 this gives you the profile id
  const dispatch = useDispatch();
console.log('viewprofileid:',id);
const { data: profile } = useSelector((state) => state.profile);

let socket = null;

  useEffect(() => {
  if (id) {
    setLoading(true);
    dispatch(fetchProfile(id)).finally(() => setLoading(false));
  }
}, [id, dispatch]);
console.log('profileData:', profile);
  useEffect(() => {
    if (profile) {
      const primary = profile?.photos?.find((p) => p.isPrimary);
      console.log('Primary Photo:', primary);
      
      if (primary) {
        const imageUrl = primary?.url
          ? `${process.env.REACT_APP_UPLOAD_IMAGE_URL}/${primary.url}`
          : userAvatar || "/default-avatar.png";
        setProfileName(imageUrl);
      }else {
        setProfileName(userAvatar);
      }
    }
  }, [profile]);

  const aboutFull =
    "I'm a warm-hearted and grounded individual who values deep connections over surface-level conversations. I grew up in a close-knit Tamil family in Coimbatore and carries the values of respect, love and togetherness at her core. An avid reader and Carnatic music enthusiast, she brings calm and joy to every room she enters. She is looking for a life partner who respects her individuality while building a meaningful life together.";

  const aboutShort = aboutFull.slice(0, 180) + "…";
  const badges = [t("verifiedProfile"), t("premiumMember"), t("recentlyActive"), t("familyOriented")];
  const DetailBox = ({ label, value }) => (
    <div className="detail-box">
      <span className="label">{label}</span>
      <span className="value">{value}</span>
    </div>
  );

  const MatchItem = ({ title, desc, percent }) => {
    return (
      <div className="match-item">
        <h4>{title}</h4>
        <p>{desc}</p>

        <div className="progress-row">
          <div className="progress-bar">
            <div
              className="progress-fill"
              style={{ width: `${percent}%` }}
            />
          </div>
          <span className="percent">{percent}%</span>
        </div>
      </div>
    );
  };

  // check user login
  const checkUserLogin = (msg) => {
    const token = localStorage.getItem("token");

    if (!token) {
      showToast(msg, "error");
      return false;
    }

    return true;
  };

  const interestProfile = async (id) =>{
    console.log('toggleInterest:',id);
    // user not login show toast
    if (!checkUserLogin("Please login to send interest.")) {
      return; // ✅ stops execution
    }
    // setInterested((prev) =>
    //   prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]
    // );
    const interest = dispatch(sendInterestToProfile(id));
    console.log('interest:', await interest);
    let message = await interest;
    console.log('toastMessage:', message?.payload?.message);
    
    showToast(message?.payload?.message || "Interest sent!", "success");
    

  }

   const shortListProfile = async (id) =>{
      console.log('toggleStar:',id);
      if (!checkUserLogin("Please login to shortlist profiles.")) {
      return; // ✅ stops execution
    }
      // setStarred((prev) =>
      //   prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]
      // );
      const shortlist = await dispatch(userAddShortlistProfile(id));
      console.log('shortlist:', shortlist);
      let message =  shortlist;
      console.log('toastMessage:', message?.payload?.message);
      showToast(message?.payload?.message || "Profile shortlisted!", "success");
    }

  const showToast = (msg, type = "success") => {
    setToast({ msg, type });
    setTimeout(() => setToast(null), 3000);
  };
  
  // Implementation for opening chat box
  function ChatModal({ isOpen, onClose, user }) {
    console.log('chatUser:', user);
    const [show, setShow] = useState(false);
    const [messages, setMessages] = useState([]);
    const [input, setInput] = useState("");
    const [conversationId, setConversationId] = useState(null);
    const [loading, setLoading] = useState(false);
  
    const chatBodyRef = useRef(null);
    const convIdRef = useRef(null);
  console.log('chatUser:', user);
  
    // ✅ Auto scroll
    useEffect(() => {
      if (chatBodyRef.current) {
        chatBodyRef.current.scrollTop =
          chatBodyRef.current.scrollHeight;
      }
    }, [messages]);
  
    // ✅ Open / Close modal
    useEffect(() => {
      if (isOpen) {
        setShow(true);
        initConversation();
      } else {
        const s = getSocket();
  
        if (convIdRef.current) {
          s.emit("leaveRoom", convIdRef.current);
          console.log("✅ Left room:", convIdRef.current);
        }
  
        setTimeout(() => {
          setShow(false);
          setMessages([]);
          setConversationId(null);
          convIdRef.current = null;
        }, 300);
      }
    }, [isOpen]);
  
    // ✅ ✅ SOCKET LISTENER (MAIN FIX)
    useEffect(() => {
      if (!conversationId) return;
  
      const s = getSocket();
  
      const handleMessage = (message) => {
        const myProfileId = localStorage.getItem("profileId");
  
        console.log("📩 Socket message:", message);
  
        // ❗ Ignore my own messages (prevents duplicate)
        if (message.sender === myProfileId) return;
  
        setMessages((prev) => [
          ...prev,
          {
            text: message.text,
            sender: "other",
          },
        ]);
      };
  
      s.on("receiveMessage", handleMessage);
  
      return () => {
        // ✅ Remove only this listener
        s.off("receiveMessage", handleMessage);
      };
    }, [conversationId]);
  
    // ✅ INIT CONVERSATION (NO SOCKET LISTENER HERE)
    const initConversation = async () => {
      if (!user) return;
  
      const myProfileId =
          localStorage.getItem(
            "profileId"
          );
      const toProfileId =
        user.fromProfile?._id ||
        user.toProfile?._id ||
        user._id;
  
      if (!toProfileId) {
        console.error(" No toProfileId");
        return;
      }
  
      console.log(" Opening chat with:", myProfileId, toProfileId);
  
      const conversation = await createConversation(myProfileId, toProfileId);
  
      if (conversation?._id) {
        const convId = conversation._id;
  
        setConversationId(convId);
        convIdRef.current = convId;
  
        const s = getSocket();
  
        // ✅ Join room only
        s.emit("joinRoom", convId);
        console.log("✅ Joined room:", convId);
  
        // ✅ Load old messages
        // LOAD OLD MESSAGES
        
                const response =
                  await getMessages(
                    convId
                  );
                const oldMessages =
                  response || [];
        
                setMessages(
                  oldMessages.map((m) => ({
                    text: m.text,
        
                    sender:
                      String(m.senderId) ===
                      String(myProfileId)
                        ? "me"
                        : "other",
                  }))
                );
        // if (Array.isArray(conversation.messages)) {
        //   setMessages(
        //     conversation.messages.map((m) => ({
        //       text: m.text,
        //       sender: m.isMe ? "me" : "other",
        //     }))
        //   );
        // } else {
        //   setMessages([]);
        // }
      } else {
        console.error("❌ No conversation ID");
      }
    };
  
    // ✅ SEND MESSAGE (Optimistic UI)
    const sendMessage = async () => {
      if (!input.trim() || !conversationId) return;
  
      const text = input.trim();
      setInput("");
  
      // ✅ Show instantly
      setMessages((prev) => [
        ...prev,
        { text, sender: "me" },
      ]);
  
      try {
        setLoading(true);
        await sendChatMessage(conversationId, text);
      } catch (err) {
        console.error("Send failed:", err);
  
        // rollback
        setMessages((prev) => prev.slice(0, -1));
      } finally {
        setLoading(false);
      }
    };
  
    const handleKeyDown = (e) => {
      if (e.key === "Enter") sendMessage();
    };
  
    if (!show) return null;
  
    const fromProfile = user || {};
    const profileURL = fromProfile?.photos?.find(
      (p) => p.isPrimary
    );
  
    const avatarUrl = profileURL?.url
      ? `${process.env.REACT_APP_UPLOAD_IMAGE_URL}/${profileURL.url}`
      : userAvatar || "/default-avatar.png";
    return (
      <div className={`chat-overlay ${isOpen ? "open" : "close"}`}>
        <div className={`chat-modal ${isOpen ? "slide-up" : "slide-down"}`}>
          
          {/* HEADER */}
          <div className="chat-header">
            <div className="chat-user">
              <img 
              src={avatarUrl} 
              alt="chat avatar"
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = userAvatar;
              }} />
              <div>
                <div className="chat-user-name">
                  {fromProfile?.fullName || user?.name}
                </div>
                <div className="chat-user-status">Active now</div>
              </div>
            </div>
            <button onClick={onClose}>✕</button>
          </div>
  
          {/* BODY */}
          <div className="chat-body" ref={chatBodyRef}>
            {messages.length === 0 && (
              <p className="no-messages">
                Say hi to start the conversation 👋
              </p>
            )}
  
            {messages.map((msg, i) => (
              <div
                key={i}
                className={`chat-bubble ${
                  msg.sender === "me" ? "right" : "left"
                }`}
              >
                {msg.text}
              </div>
            ))}
          </div>
  
          {/* INPUT */}
          <div className="chat-input">
            <input
              value={input}
              onChange={(e) => setInput(e.target.value)}
              onKeyDown={handleKeyDown}
              placeholder="Type a message..."
              disabled={!conversationId}
            />
            <button
              onClick={sendMessage}
              disabled={loading || !conversationId}
            >
              {loading ? "..." : "Send"}
            </button>
          </div>
        </div>
      </div>
    );
  }

  const getSocket = () => {
  if (!socket || !socket.connected) {
    socket = io(process.env.REACT_APP_SOCKET_URL || "http://localhost:5000", {
      auth: { token: localStorage.getItem("token") },
      transports: ["websocket"],
    });
    socket.on("connect", () => console.log("✅ Socket connected:", socket.id));
    socket.on("disconnect", () => console.log("❌ Socket disconnected"));
  }
  return socket;
};

//check payment status before allowing to chat
const checkPaymentStatus = (profile) => {
  const user = localStorage.getItem("user");
  const userFromStorage = JSON.parse(user);  
  if (userFromStorage?.paymentStatus === "SUCCESS") {
    setSelectedUser(profile);
  } else {
    showToast("Please upgrade your plan to message this user.", "error");
    // alert("Please upgrade your plan to message this user.");
  }
};

const getPhoneDisplay = (phone, isPremium, isMatched, paymentStatus) => {
  const user = localStorage.getItem("user");
  const userFromStorage = JSON.parse(user); 
  if (!phone) return "N/A";
  if (isPremium || isMatched || userFromStorage?.paymentStatus === "SUCCESS") return phone; // full reveal
  return phone.replace(/^(\d{2})\d{4}(\d{4})$/, "$1********");
};

  return (
    
    <div className="page">
      {loading && <Loader />}
      {selectedUser && (
    <ChatModal
      isOpen={!!selectedUser}
      user={selectedUser}
      onClose={() => setSelectedUser(null)}
    />
  )}
      <div className="back-btn" onClick={() => window.history.back()}>
        ←
      </div>
      {/* Card */}
      <div className="profilecard">
        {/* Left: Photo */}
        {/* <div className="photo-wrap-background"> */}
        <div className="photo-wrap">
          <div className="photo-inner">
            <img
              src={profileImageName || userAvatar}
              alt="Divya Menon"
               style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
                objectPosition: "top center", 
                display: "block",
              }}
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = userAvatar;
              }}
            />
          </div>
        </div>
        {/* </div> */}


        {/* Right: Info */}
        <div className="info">
          <h1 className="name">{
  profile?.fullName
    ? profile.fullName
    : profile?.firstName
      ? `${profile.firstName} ${profile.lastName || ""}`
      : "N/A"
}</h1>
          <p className="meta">{profile?.age || "N/A"} {t("years")} · {profile?.height || "N/A"}</p>
          <p className="location">
            <span className="pin"><img src={profilelocation} alt="Pin" className="profileicon" /></span> {profile?.location?.city || "N/A"}, {profile?.location?.state || "N/A"}, {profile?.location?.country || "India"}
          </p>

          <div className="quote">
            "A quiet soul who finds beauty in books, music, and warm chai mornings."
          </div>
          {localStorage.getItem("token") && (
            <span>
          <p className="profile-compat-label">Compatibility with your profile</p>
          <p className="match-score">{profile?.matchPercent || 0}% Match</p>
          <div className="bar-bg">
            <div className="bar-fill" />
          </div>
          <p className="match-sub">Based on values, location &amp; lifestyle preferences</p>
          </span>
 )}
          {/* Actions */}
          <div className="actions">
            <button
              className={`btn-primary${interested ? " active" : ""}`}
              onClick={() => interestProfile(id)}
            >
              {/* <span>{interested ? "♥" : "♡"}</span> */}
              <span><img src={heartIcon} alt="Heart" className="profileicon" /></span>
              {profile?.interestStatus === t("interestAccepted") ? t("interestAccepted")
              : profile?.interestStatus === t("interestRejected") ? t("interestRejected")
              : profile?.interestStatus === t("interestSent") ? t("interestSent") : t("sendInterest")}
              {/* {interested ? "Interest Sent" : "Send Interest"} */}
            </button>

            <button className="btn-secondary" onClick={() => checkPaymentStatus(profile)}>
              <span><img src={messageIcon} alt="Message" className="profileicon" /></span> {t("message")}
            </button>

            <button
              className={`btn-icon${saved ? " saved" : ""}`}
              onClick={() => shortListProfile(id)}
              title="Save profile"
            >
              <img src={profile?.isShortlisted ? removefavStarIcon : addfavStarIcon} alt="favStarIcon" className="favstar-icon" />
              {/* <img
                src={whiteStarIcon}
                alt="Save"
                className="profileicon"
              /> */}
            </button>
          </div>
        </div>
      </div>

      {/* Extra Sections */}
      <div className="extra-sections">

        {/* Tags */}
        <div className="tags-row">
          {[t("verifiedProfile"), t("premiumMember"), t("recentlyActive"), t("familyOriented")].map((tag, i) => (
            <span key={i} className="tag-pill">{tag}</span>
          ))}
        </div>

        {/* About Section */}
        <div className="about-card">
          <div className="profile-about-section-title">
            <span >About {profile?.fullName || "User"}</span>
          </div>
          <p>
            {profile?.aboutMe ? profile.aboutMe : expanded ? aboutFull : aboutShort}
          </p>

          <span className="read-more"><img src={readMoreIcon} alt="Read more" className="profiledownarrowicon" /> Read more</span>
        </div>

        {/* Basic Details */}
        <div className="details-card">
          <div className="profile-section-title">
            <span>{t("basicDetails")}</span>
          </div>

          <div className="details-grid">
            <DetailBox label={t("age_range_label")} value={`${profile?.age} Years`} />
            <DetailBox label={t("height_label")} value={`${profile?.height} ft`} />
            <DetailBox label={t("location_label")} value={profile?.location?.state || "Coimbatore, TN"} />
            <DetailBox label={t("religion_label")} value={profile?.religion || ""} />

            <DetailBox label={t("caste_label")} value={profile?.caste || "Iyer (Brahmin)"} />
            <DetailBox label={t("marital_status_label")} value={profile?.maritalStatus || "Never Married"} />
            <DetailBox label={t("mother_tongue_label")} value={profile?.motherTongue || "Tamil"} />
            <DetailBox label={t("phone_number_label")} value={getPhoneDisplay(profile?.phone, profile?.isPremium, profile?.isMatched,profile?.paymentStatus) || "N/A"} />
            {/* <DetailBox label="Complexion" value={profile?.complexion || "Fair"} /> */}
            {/* <DetailBox label="Body Type" value={profile?.bodyType || "Slim"} /> */}
          </div>
        </div>

        {/* Professional Details */}
        <div className="details-card">
          {/* <h3>Basic Details</h3> */}
          <div className="profile-section-title">
            <span>{t("professionalDetails")}</span>
          </div>

          <div className="details-grid">
            <DetailBox label={t("education_label")} value={profile?.education || "N/A"} />
            <DetailBox label={t("profession_label")} value={profile?.profession || "N/A"} />
            {/* <DetailBox label="Company" value={profile?.company || "N/A"} /> */}

            <DetailBox label={t("work_city_label")} value={profile?.location?.city || "N/A"} />
            <DetailBox label={t("monthly_income_label")} value={profile?.salary || "N/A"} />
            {/* <DetailBox label="Work Style" value={profile?.workStyle || "N/A"} /> */}
          </div>
        </div>
   
        {/* Lifestyle Details */}
        <div className="lifestyle-card">

          {/* Title with line */}
          <div className="profile-section-title">
            <span>{t("lifestyle_label")}</span>
          </div>

          {/* Daily Habits */}
          <div className="lifestyle-group">
            <p className="group-title">{t("daily_habits")}</p>
            <div className="pill-container">
              {profile?.diet && <span className="pill">{profile.diet}</span>}
              {profile?.smoking && <span className="pill">{`Smoking: ${profile.smoking}`}</span>}
              {profile?.drinking && <span className="pill">{`Drinking: ${profile.drinking}`}</span>}
              {/* {["Vegetarian", "Non-Smoker", "Non-Drinker", "Yoga Practice"].map((item, i) => (
                <span key={i} className="pill">{item}</span>
              ))} */}
            </div>
          </div>

          {/* Hobbies */}
          <div className="lifestyle-group">
            <p className="group-title">{t("hobbies_interests")}</p>
            <div className="pill-container">
              {["Reading", "Carnatic Music", "Cooking", "Travelling", "Sketching", "Gardening", "Cinema"].map((item, i) => (
                <span key={i} className="pill">{item}</span>
              ))}
            </div>
          </div>

        </div>

        {/* Partner Preferences */}
        <div className="details-card">
          {/* <h3>Basic Details</h3> */}
          <div className="profile-section-title">
            <span>{t("partnerPreferences")}</span>
          </div>

          <div className="details-grid">
            <DetailBox label={t("age_range_label")} value={`${profile?.partnerPreferences?.ageFrom }-${profile?.partnerPreferences?.ageTo }`} />
            <DetailBox label={t("location_label")} value={profile?.partnerPreferences?.state || "Coimbatore"} />
            <DetailBox label={t("education_label")} value={profile?.partnerPreferences?.education || "Graduate & above"} />
            <DetailBox label={t("height_label")} value={profile?.partnerPreferences?.height || "5.0"} />
            <DetailBox label={t("profession_label")} value={profile?.partnerPreferences?.profession || "Any Reputed Profession"} />
            <DetailBox label={t("monthly_income_label")} value={profile?.partnerPreferences?.salary || "5-12LPA"} />
            <DetailBox label={t("religion_label")} value={profile?.partnerPreferences?.religion || "Hindu"} />
            <DetailBox label={t("caste_label")} value={profile?.partnerPreferences?.caste || "Iyer (Brahmin)"} />
            {/* <DetailBox label={t("diet")} value={profile?.partnerPreferences?.diet || "Vegetarian Preferred"} /> */}

            {/* <DetailBox label={t("habits")} value="Non-Smoker, Non-Drinker" /> */}
            {/* <DetailBox label={t("family_type")} value="Open to Both" /> */}
          </div>
        </div>

        {/* Match Analysis */}
        <div className="match-card">

          {/* Title */}
          <div className="section-title">
            <span>{t("why_this_match")}</span>
          </div>

          <p className="match-subtitle">{t("ai_compatibility_analysis")}</p>

          {/* Items */}
          <MatchItem
            title={t("sharedValuesTitle")}
            desc={t("sharedValuesDesc")}
            percent={95}
          />

          <MatchItem
            title={t("locationTitle")}
            desc={t("locationDesc")}
            percent={98}
          />

          <MatchItem
            title={t("lifestyleTitle")}
            desc={t("lifestyleDesc")}
            percent={90}
          />

          <MatchItem
            title={t("educationTitle")}
            desc={t("educationDesc")}
            percent={88}
          />

        </div>

        {/* Quote */}
        <div className="match-quote">
          "{t("match_quote")}"
        </div>



      </div>
      {/* Bottom Sticky Bar */}
      <div className="bottom-bar-wrapper">
        <div className="bottom-bar">

          <div className="bottom-left">
            <h4>{
  profile?.fullName
    ? profile.fullName
    : profile?.firstName
      ? `${profile.firstName} ${profile.lastName || ""}`
      : "N/A"
}, {profile?.age || 27}</h4>
            <p>{profile?.location?.state || "N/A"} • {profile?.match || 92}% {t("match")}</p>
          </div>

          <div className="bottom-right">
            <button className="interest-btn" onClick={() => interestProfile(id)}>
              ♡ {t("sendInterest")}
            </button>

            {/* <button
              className={`fav-btn ${saved ? "active" : ""}`}
              onClick={() => setSaved(!saved)}
            > */}
              <button
              className={`fav-btn ${profile?.isShortlisted ? "active" : ""}`}
              onClick={() => shortListProfile(id)}
            >
              {/* <img src={profile?.isShortlisted ? removefavStarIcon : addfavStarIcon} alt="favStarIcon" className="favstar-icon" /> */}
              <img
                src={whiteStarIcon}
                alt="Save"
                className="profileicon"
              />

            </button>
          </div>

        </div>
      </div>
      {toast &&
       <div className={`toast ${toast.type}`}>{toast.msg}</div>
      }
    </div>
  );

}

/* ---------- Reusable Components (UNCHANGED) ---------- */

const Section = ({ title, children }) => (
  <div className="section">
    <h3>{title}</h3>
    {children}
  </div>
);

const Grid = ({ children }) => (
  <div className="grid">{children}</div>
);

const Item = ({ label, value }) => (
  <div className="item">
    <span>{label}</span>
    <strong>{value}</strong>
  </div>
);

const TagGroup = ({ tags }) => (
  <div className="tags">
    {tags.map((t) => (
      <span key={t}>{t}</span>
    ))}
  </div>
);

const MatchBar = ({ label, value }) => (
  <div className="match-row">
    <p>{label}</p>
    <div className="progress">
      <div style={{ width: `${value}%` }} />
    </div>
    <span>{value}%</span>
  </div>
);


